// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner-module--banner--30Hz6"};